import script from "./GrouperInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./GrouperInfo.vue?vue&type=script&lang=ts&setup=true"

import "./GrouperInfo.vue?vue&type=style&index=0&id=a53eb1a8&lang=scss"

const __exports__ = script;

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
